class DefaultController {
  constructor(appModel, utils) {
    "ngInject";
    this.appModel = appModel;
    this.utils = utils;
  }
}

export default DefaultController;



// WEBPACK FOOTER //
// ./client/app/pages/default/default.controller.js